var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-img',{staticClass:"ltk-post-pin",attrs:{"src":require('@/assets/images/post-pin/pin.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }